import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const REGISTRATION_WIZARD_AB_TEST_ID: string = OngoingABTests.REGISTRATION_WIZARD;
export const REGISTRATION_WIZARD_CONTROL_VARIANT = "rp_registration_wizard_2026_10_control" as const;
export const REGISTRATION_WIZARD_TREATMENT_VARIANT = "rp_registration_wizard_2026_10_treatment" as const;

/**
 * A/B test managed by Amplitude Experiment. The Amplitude flag must expose `rp_registration_wizard_2026_10_control`
 * and `rp_registration_wizard_2026_10_treatment` variants. The treatment replaces the legacy authentication modals of the
 * registration flow with the stepped registration wizard; the control keeps the legacy modals and the previous click behaviour
 * of the entries. What follows the authentication (the unlock choice and its payoff) is decided by `rp-after-register-choice`,
 * but outside the property page (lead CTAs, Google One Tap) the unlock choice is offered only in this treatment.
 * Override in dev: ?ab_test_experiment=rp-registration-wizard&ab_test_variant=rp_registration_wizard_2026_10_treatment|rp_registration_wizard_2026_10_control
 */
export const registrationWizardAbTest: IABTestConfiguration = {
    id: REGISTRATION_WIZARD_AB_TEST_ID,
    name: OngoingABTests.REGISTRATION_WIZARD,
    expires: new Date(2027, 0, 1),
    path: rpAppPath.base,
    variants: [REGISTRATION_WIZARD_CONTROL_VARIANT, REGISTRATION_WIZARD_TREATMENT_VARIANT],
    withSSR: false,
    matchOnAllPaths: true,
    useAmplitude: true
};
import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const REGISTRATION_WIZARD_AB_TEST_ID: string = OngoingABTests.REGISTRATION_WIZARD;
export const REGISTRATION_WIZARD_CONTROL_VARIANT = "rp_registration_wizard_2026_10_control" as const;
export const REGISTRATION_WIZARD_TREATMENT_VARIANT = "rp_registration_wizard_2026_10_treatment" as const;

/**
 * A/B test managed by Amplitude Experiment. The Amplitude flag must expose `rp_registration_wizard_2026_10_control`
 * and `rp_registration_wizard_2026_10_treatment` variants. The treatment replaces the legacy authentication modals of the
 * registration flow with the stepped registration wizard; the control keeps the legacy modals and the previous click behaviour
 * of the entries. What follows the authentication (the unlock choice and its payoff) is decided by `rp-after-register-choice`,
 * but outside the property page (lead CTAs, Google One Tap) the unlock choice is offered only in this treatment.
 * Override in dev: ?ab_test_experiment=rp-registration-wizard&ab_test_variant=rp_registration_wizard_2026_10_treatment|rp_registration_wizard_2026_10_control
 */
export const registrationWizardAbTest: IABTestConfiguration = {
    id: REGISTRATION_WIZARD_AB_TEST_ID,
    name: OngoingABTests.REGISTRATION_WIZARD,
    expires: new Date(2027, 0, 1),
    path: rpAppPath.base,
    variants: [REGISTRATION_WIZARD_CONTROL_VARIANT, REGISTRATION_WIZARD_TREATMENT_VARIANT],
    withSSR: false,
    matchOnAllPaths: true,
    useAmplitude: true
};
